import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Row, Col, Checkbox, Alert, Button, Spin, Timeline, Select } from 'antd';
import BaseCheckboxes from '@/components/Elements/BaseCheckboxes';
import BaseSelect from '@/components/Elements/BaseSelect';
import { chunkGroup } from '@/utils/permission';
import IntlMessages from '@/components/IntlMessage';
import { NotificationManager } from 'react-notifications';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar/index';

import { getAllPermissions, updateRolePermissions, getPermissionsByRole, getPermissionsByUser } from '@/redux/actions/PermissionActions';

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/permissions',
        breadcrumbName: 'Phân quyền',
    },
]

const PermissionGroup = ({ groups, permissionGroup, onCheckAll, onCheck }) => (
    <React.Fragment>
        {
            groups.map((groupChunk, index) => {
                return (
                    <Row gutter={20} style={{ height: 'max-content' }} key={index}>
                        {
                            groupChunk.map((group, index) => {
                                let groupName = group[0].route_name.split('.')[1];
                                let groupChecked = false;
                                if (permissionGroup[groupName]) {
                                    if (permissionGroup[groupName].length === group.length) groupChecked = true;
                                }

                                //console.log(groupChecked);
                                return (
                                    <Col lg={6} md={6} sm={24} xs={24} key={index} className="mb-4" >
                                        <Card
                                            title={<IntlMessages id={`admin.${groupName}`} />}
                                            size="small"
                                            extra={
                                                <Checkbox
                                                    onChange={(e) => onCheckAll(e, groupName, group)}
                                                    defaultChecked={groupChecked}
                                                ></Checkbox>
                                            }
                                            style={{ marginBottom: '20px', height: '100%' }}
                                        >
                                            <BaseCheckboxes
                                                options={group}
                                                optionLabel="name"
                                                optionValue="id"
                                                vertical
                                                onChange={(checkedValues) => onCheck(checkedValues, groupName)}
                                                value={permissionGroup[groupName]}
                                                intl={true}
                                            />
                                        </Card>
                                    </Col>
                                )
                            })
                        }
                    </Row>
                )
            })
        }
    </React.Fragment>
)

function handlePermissions(permissions) {
    var permissionGroup = {};
    permissions.forEach(permission => {
        let groupName = permission.route_name.split('.')[1];
        if (!permissionGroup[groupName]) {
            permissionGroup[groupName] = [permission.id];
        } else {
            permissionGroup[groupName] = [...permissionGroup[groupName], permission.id];
        }
    })

    return permissionGroup;
}

class UserPermission extends Component {
    state = {
        permissionGroup: {},
        isLoading: false,
        currentRole: '',
        currentUser: '',
        roles: []
    }

    componentDidMount() {
        this.props.getAllPermissions();

    }

    onChangeRole(value) {
        this.setState({ currentRole: value, isLoading: true }, () => {
            this.props.getPermissionsByRole(this.state.currentRole).then(permissions => {
                var permissionGroup = handlePermissions(permissions);

                this.setState({ permissionGroup: permissionGroup, currentUser: '', isLoading: false });
            })
        })
    }

    onChangeUser(user) {
        if (user) {
            this.setState({ currentUser: user, isLoading: true }, () => {
                this.props.getPermissionsByUser(this.state.currentUser).then(permissions => {
                    var permissionGroup = handlePermissions(permissions);

                    this.setState({ permissionGroup: permissionGroup, isLoading: false });
                })
            })
        } else {
            this.props.getPermissionsByRole(this.state.currentRole).then(permissions => {
                var permissionGroup = handlePermissions(permissions);

                this.setState({ permissionGroup: permissionGroup, currentUser: '', isLoading: false });
            })
        }
    }

    onCheck = (checkedValues, groupName) => {
        this.setState({
            permissionGroup: {
                ...this.state.permissionGroup,
                [groupName]: checkedValues
            }
        })
    }

    onCheckAll = (e, groupName, group) => {
        let values = group.map(item => item.id)
        if (e.target.checked) {
            this.setState({
                permissionGroup: {
                    ...this.state.permissionGroup,
                    [groupName]: values
                }
            })
        } else {
            this.setState({
                permissionGroup: {
                    ...this.state.permissionGroup,
                    [groupName]: []
                }
            })
        }
    }

    submit() {
        if (!this.state.currentRole) {
            NotificationManager.error("Bạn chưa chọn vai trò!")
        } else {
            let keys = Object.keys(this.state.permissionGroup);
            let permissionArr = [];
            keys.forEach(key => {
                permissionArr = [...permissionArr, ...this.state.permissionGroup[key]];
            });

            var data = {
                role: this.state.currentRole,
                permissions: permissionArr
            }

            if (this.state.currentUser) data.user = this.state.currentUser;

            this.props.updateRolePermissions(data);
        }
    }

    render() {
        var { permissions, config } = this.props;
        var { isLoading, currentRole, permissionGroup, currentUser } = this.state;

        var users = [];
        if (currentRole) {
            users = config.users.filter(item => item.role_id == currentRole);
        }

        //console.log(permissions);
        const SetttingPermissions = ['config', 'service_visibility', 'customer_care_categories', 'instruction_templates',
            'prescription_templates', 'procedures', 'product_status', 'services', 'diseases',
            'blood_groups', 'customer_class', 'customer_status', 'interaction_statuses', 'interaction_types',
            'customer_source', 'unit', 'relationship_types', 'document_categories'];
        const CustomerPermissions = ['customer', 'direct_consultations', 'vouchers', 'orthodontic_comments',
            'orthodontic_plans', 'general_exams', 'orthodontic_exams', 'medical_records',
            'images', 'milestones', 'customer_complaints', 'telesale_follow_up',
            'customer_care_logs', 'additional_cost', 'customer_payment', 'customer_medical',
            'lookup_customer', 'customer_prospect',
            'customer_services', 'customer_service_commission_setup', 'customer_service_staff_change', 'appointment', 'customer_group'];
        const BranchManagementPermissions = ['permissions', 'branches', 'user', 'role_groups', 'roles', 'documents'];
        const WarehousePermissions = ['warehouse_supplier', 'product_receipt_export', 'product_warehouse',
            'product_supplier', 'product_group', 'product', 'product_receipt_import'];
        const FanpagePermissions = ['messenger', 'page_manager', 'zalo'];
        const ThuchiPermissions = ['receipt', 'customer_fund_transfer', 'customer_balance', 'customer_refund', 'customer_deposit', 'payment_voucher', 'cash_book', 'branch_fund'];
        const HoatdongPermissions = ['audit_logs', 'view_phonenumber'];
        const HoaHongPermissions = ['commission', 'commission_adjustment', 'commission_recovery', 'commission_refund',
            'commission_result', 'commission_hold', 'commission_period', 'commission_aggregate', 'commission_reconciliation', 'commission_approval',
            'commission_payout', 'commission_config', 'commission_payout_schedule'
        ];

        const TheKhachHang = ['card_issued_counts', 'card_pending_customers', 'card_release_trackings', 'card_types'];
        const DuAn = ['project', 'project_job'];
        const PhanCaLamViec = ['schedule_areas', 'schedule_area_functions', 'schedule_jobs', 'schedule_shifts'];
        const LaBo = ['labos', 'labo_cases'];

        const DoctorPermissions = ['doctor_appointments', 'doctor_customers', 'treatment_sessions'];

        let SetttingGroup = [];
        let CustomerGroup = [];
        let others = [];
        let BranchManagementGroup = [];
        let WarehouseGroup = [];
        let FanpageGroup = [];
        let ThuchiGroup = [];
        let HoatdongGroup = [];
        let HoaHongGroup = [];
        let DoctorGroup = [];
        let TheKhachHangGroup = [];
        let DuAnGroup = [];
        let PhanCaLamViecGroup = [];
        let LaBoGroup = [];

        permissions.forEach(permission => {
            if (SetttingPermissions.indexOf(permission.resource) >= 0) {
                SetttingGroup.push(permission);
            } else if (CustomerPermissions.indexOf(permission.resource) >= 0) {
                CustomerGroup.push(permission);
            } else if (BranchManagementPermissions.indexOf(permission.resource) >= 0) {
                BranchManagementGroup.push(permission);
            } else if (WarehousePermissions.indexOf(permission.resource) >= 0) {
                WarehouseGroup.push(permission);
            } else if (FanpagePermissions.indexOf(permission.resource) >= 0) {
                FanpageGroup.push(permission);
            } else if (ThuchiPermissions.indexOf(permission.resource) >= 0) {
                ThuchiGroup.push(permission);
            } else if (HoatdongPermissions.indexOf(permission.resource) >= 0) {
                HoatdongGroup.push(permission);
            } else if (HoaHongPermissions.indexOf(permission.resource) >= 0) {
                HoaHongGroup.push(permission);
            } else if (DoctorPermissions.indexOf(permission.resource) >= 0) {
                DoctorGroup.push(permission);
            } else if (TheKhachHang.indexOf(permission.resource) >= 0) {
                TheKhachHangGroup.push(permission);
            } else if (DuAn.indexOf(permission.resource) >= 0) {
                DuAnGroup.push(permission);
            } else if (PhanCaLamViec.indexOf(permission.resource) >= 0) {
                PhanCaLamViecGroup.push(permission);
            } else if (LaBo.indexOf(permission.resource) >= 0) {
                LaBoGroup.push(permission);
            } else {
                others.push(permission);
            }
        });

        SetttingGroup = chunkGroup(SetttingGroup);
        CustomerGroup = chunkGroup(CustomerGroup);
        others = chunkGroup(others);
        BranchManagementGroup = chunkGroup(BranchManagementGroup)
        WarehouseGroup = chunkGroup(WarehouseGroup)
        FanpageGroup = chunkGroup(FanpageGroup)
        ThuchiGroup = chunkGroup(ThuchiGroup)
        HoatdongGroup = chunkGroup(HoatdongGroup)
        HoaHongGroup = chunkGroup(HoaHongGroup)
        DoctorGroup = chunkGroup(DoctorGroup)
        TheKhachHangGroup = chunkGroup(TheKhachHangGroup)
        DuAnGroup = chunkGroup(DuAnGroup)
        PhanCaLamViecGroup = chunkGroup(PhanCaLamViecGroup)
        LaBoGroup = chunkGroup(LaBoGroup)

        return (
            <div className="mb-4">
                <PageTitle title="Phân quyền user" routes={routes} />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={false}
                        showSearch={false}
                        showFilter={false}
                    >
                        <span>Chọn loại quyền:&nbsp;</span>
                        <Select
                            showSearch
                            placeholder="Chọn một vai trò"
                            style={{ width: '250px' }}
                            onChange={(value) => this.onChangeRole(value)}
                            options={config.role_trees}
                            optionFilterProp="children"
                            allowClear
                            className="table-button"
                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                        />
                        <BaseSelect
                            options={users || []}
                            showSearch
                            allowClear={false}
                            value={currentUser || null}
                            optionValue="user_id"
                            optionLabel="display_name"
                            style={{ width: '250px' }}
                            placeholder="Tất cả nhân viên"
                            className="table-button"
                            onChange={(value) => this.onChangeUser(value)}
                        />

                    </TableActionBar>
                </div>

                <div className="mt-4"></div>
                <Alert
                    message="Lưu ý"
                    description="User với quyền Admin luôn có toàn bộ quyền truy cập."
                    className='fix-alert-element'
                    showIcon
                />
                <div className="mt-4"></div>
                {
                    isLoading ? (
                        <div className="text-center">
                            <Spin size="large" />
                        </div>
                    ) : (
                        <React.Fragment>
                            <Timeline>
                                <Timeline.Item>
                                    <h6>Cài đặt</h6>
                                    <PermissionGroup groups={SetttingGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Quản lý cơ sở</h6>
                                    <PermissionGroup groups={BranchManagementGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Khách hàng & dịch vụ</h6>
                                    <PermissionGroup groups={CustomerGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Thẻ khách hàng</h6>
                                    <PermissionGroup groups={TheKhachHangGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Bác sĩ</h6>
                                    <PermissionGroup groups={DoctorGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Kho</h6>
                                    <PermissionGroup groups={WarehouseGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Quản lý fanpage</h6>
                                    <PermissionGroup groups={FanpageGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Thu chi</h6>
                                    <PermissionGroup groups={ThuchiGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Hoa hồng</h6>
                                    <PermissionGroup groups={HoaHongGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Dự án</h6>
                                    <PermissionGroup groups={DuAnGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Phân ca làm việc</h6>
                                    <PermissionGroup groups={PhanCaLamViecGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Đối tác labo</h6>
                                    <PermissionGroup groups={LaBoGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Hoạt động</h6>
                                    <PermissionGroup groups={HoatdongGroup} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                                <Timeline.Item>
                                    <h6>Các quyền khác</h6>
                                    <PermissionGroup groups={others} permissionGroup={permissionGroup} onCheck={this.onCheck} onCheckAll={this.onCheckAll} />
                                </Timeline.Item>
                            </Timeline>
                            <Row justify="end" style={{ position: 'fixed', bottom: '20px', right: '20px' }}>
                                <Button type="primary" onClick={() => this.submit()}>Xác nhận</Button>
                            </Row>
                        </React.Fragment>
                    )
                }


            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        permissions: state.permission.permissions,
        permissionsByRole: state.permission.permissionsByRole,
        config: state.config,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAllPermissions: () => dispatch(getAllPermissions()),
        updateRolePermissions: (data) => dispatch(updateRolePermissions(data)),
        getPermissionsByRole: (role) => dispatch(getPermissionsByRole(role)),
        getPermissionsByUser: (user) => dispatch(getPermissionsByUser(user))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPermission);
